<div *ngIf="isStandalone">
    <i class="fa fa-chevron-left bread-icon"></i>
    <a (click)="back()" style="color: #009ade;">Back To {{isAdmin ? 'Integrations' : 'Onboarding'}}</a>
</div>
<div [class.component-container]="isStandalone" fxLayoutAlign="center">
    <div [class.manage-card]="isStandalone" fxFlex="80%">
        <div fxLayoutAlign="center" *ngIf="isStandalone">
            <span class="header"> Manage {{getManageText()}}</span>
        </div>
        <div class="sub-header" fxLayoutAlign="center" *ngIf="isStandalone">
            <span> {{selectedBrand.name}}</span>
        </div>

        <div *ngFor="let invite of sentInvites; let i = index">
            <div class="invite-container">
                <span *ngIf="!isStandalone" fxLayout="row" class="account-header">
                    Account {{i + 1}} -&nbsp; <span>{{getStatusText(invite)}}</span>
                </span>
                <div fxLayout="row">
                    <div fxLayout="column" fxFlex="50%">
                        <span fxLayout="row" class="invite-header">
                            Name
                        </span>
                        <span fxLayout="row" class="invite-text">
                            {{invite.name}}
                        </span>
                        <span fxLayout="row" class="invite-header">
                            Email
                        </span>
                        <span fxLayout="row" class="invite-text">
                            {{invite.email}}
                        </span>
                        <span fxLayout="row" *ngIf="!invite.completed && invite.status === statuses.pending">
                             <span fxLayout="column" fxFlex="50%">
                                 <span class="invite-header">Date Sent</span>
                                 <span class="invite-text">{{getDisplayDate(invite.createdDate)}}</span>
                             </span>
                            <span fxLayout="column" fxFlex="50%">
                                 <span class="invite-header">Expiration Date</span>
                                 <span class="invite-text">{{getDisplayDate(invite.expDate)}}</span>
                             </span>
                         </span>
                        <span fxLayout="row" *ngIf="invite.completed">
                            <span fxLayout="column" fxFlex="50%">
                                <span class="invite-header">Activated Date</span>
                                <span class="invite-text">{{getDisplayDate(invite.completedDate)}}</span>
                            </span>
                         </span>
                        <span fxLayout="row" *ngIf="invite.status === statuses.disabled">
                            <span fxLayout="column" fxFlex="50%">
                                <span class="invite-header">Disabled Date</span>
                                <span class="invite-text">{{getDisplayDate(invite.disabledDate)}}</span>
                            </span>
                         </span>
                        <span fxLayout="row" *ngIf="invite.status === statuses.expired">
                            <span fxLayout="column" fxFlex="50%">
                                <span class="invite-header">Expired Date</span>
                                <span class="invite-text">{{getDisplayDate(invite.expDate)}}</span>
                            </span>
                         </span>
                    </div>
                    <div fxLayout="column" fxFlex="50%">
                        <div fxLayout="row wrap" fxLayoutGap="10%">
                            <div *ngFor="let int of invite.integrations" fxLayout="column" fxLayoutAlign="center" class="int-card">
                                <img mat-card-image [src]="getIntImg(int)" [alt]="int" class="integration-logo" />
                                <div class="int-status" fxLayout="row" [ngClass]="{'green': getIntStatus(int) === 'Active'}">
                                    <mat-icon *ngIf="getIntStatus(int) === 'Pending'">schedule</mat-icon>
                                    <mat-icon *ngIf="getIntStatus(int) === 'Active'">thumb_up</mat-icon>
                                    <span>{{getIntStatus(int)}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div fxLayout="row" class="int-btns" fxLayoutGap="3%">
                    <button [disabled]="inviteDisabled(invite)" color="primary" (click)="disable(invite)" mat-stroked-button>DISABLE LINKS</button>
                    <button [disabled]="inviteDisabled(invite)" color="primary" (click)="resend(invite)" mat-stroked-button>RESEND</button>
                </div>
            </div>
        </div>
        <div *ngIf="!sentInvites || sentInvites.length === 0">
            <div class="no-invites-message">
                No integrations to manage yet. Get started by setting up your integrations and inviting managers.
            </div>
        </div>
    </div>
</div>